import { useParsedMessageContent } from '@web/conversations/Message/MessageContent/messageContent.hooks';

import { Wrapper } from './messageContent.styles';

type Props = {
  content: string;
  editedDateLabel?: string | null;
  previewMode?: boolean;
};

export const MessageContent = ({ content, editedDateLabel = null, previewMode }: Props) => {
  const parsedContent = useParsedMessageContent(content, editedDateLabel);

  return <Wrapper as="div" dangerouslySetInnerHTML={parsedContent} previewMode={previewMode} />;
};
